import { debounce } from 'underscore';
import $ from 'jquery';
const debounceTime = 300;

class ScreenSizeUtil {
    constructor() {
        this._measureSize();
        this.onHandleResize();
    }

    get mediaQueryModel() {
        return [
            {
                size: 'small',
                query: 'only screen and (max-width: 40em)'
            },
            {
                size: 'medium',
                query: 'only screen and (min-width: 40.063em) and (max-width: 64em)'
            },
            {
                size: 'large',
                query: 'only screen and (min-width: 64.063em) and (max-width: 90em)'
            },
            {
                size: 'xlarge',
                query: 'only screen and (min-width: 90.063em) and (max-width: 120em)'
            },
            {
                size: 'xxlarge',
                query: 'only screen and (min-width: 120.063em)'
            }
        ];
    }

    _register({ size, query }) {
        if (window.matchMedia(query).matches) {
            this._setSize(size);
        }
    }

    _measureSize() {
        this.mediaQueryModel.forEach(this._register.bind(this));
    }

    _setSize(size) {
        this.size = size;
    }

    onHandleResize() {
        this._debouncedFunc = debounce(() => {
            this._measureSize();
        }, debounceTime);
        $(window).on('resize', this._debouncedFunc);
    }

    getSize() {
        return this.size;
    }

    offHandleResize() {
        $(window).off('resize', this._debouncedFunc);
    }
}

let screenSizeUtil = new ScreenSizeUtil();

export default screenSizeUtil;
